<template>
  <!-- team profile -->
  <div class="card sf">
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-sheet
          elevation="0"
          class="px-5 py-2 text-center"
          rounded
          color="#57bc90"
          style="min-height: 70vh"
        >
          <!--team depth data table -->
          <div class="mt-2">
            <v-data-table
              dense
              :headers="TeamHeaders"
              :items="player"
              class="elevation-1"
              sort-by="DraftKingsSalary"
              sort-desc
            >
              <!-- player name -->
              <template v-slot:item.Name="{ item }">
                <router-link
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: sportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  {{ item.Name }}
                </router-link>
              </template>
              <!-- player name ends -->

              <!--status  -->
              <template v-slot:item.InjuryStatus="{ item }">
                <!-- Blue dot - 'active',
                green dot - 'positive',
                yellow dot -'intermediary'
                red dot - 'negative' -->

                <v-row>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == null"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="positive" pulse />
                      </v-col>
                    </template>
                    <span>Healthy</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == 'Out'"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="negative" pulse />
                      </v-col>
                    </template>
                    <span>Out</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Questionable'"
                      >
                        <status-indicator status="intermediary" pulse />
                      </v-col>
                    </template>
                    <span>Questionable</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Probable'"
                      >
                        <status-indicator status="active" pulse />
                      </v-col>
                    </template>
                    <span>Probable</span>
                  </v-tooltip>
                </v-row>
              </template>
              <!-- status -->

              <!-- FPPG -->
              <template v-slot:item.FPPG="{ item }">
                <p class="caption">{{ item.FPPG >> 0 }}</p>
              </template>
              <!-- FPPG ends -->
            </v-data-table>
          </div>

          <!--team depth data table ends -->
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "TeamPlayers",
  props: {
    player: {
      type: Array,
      default: () => [],
    },
    sportId: {
      type: [String, Number],
      default: () => "",
    },
  },
  data() {
    return {
      TeamHeaders: [
        {
          text: "Position",
          value: "Position",
          sortable: false,
        },
        { text: "Player", value: "Name" },
        { text: "Status", value: "InjuryStatus" },
        // { text: "FLS", value: "fls" },
        { text: "Salary($)", value: "DraftKingsSalary" },
        { text: "FPPG", value: "FPPG" },
      ],
    };
  },
};
</script>

<style scoped></style>
